module.exports = __webpack_public_path__ + "static/media/ic_erazer_selected.28800f57.svg";